import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import styles from './index.scss'
import Icon from '../../../../elementals/icon'

const cx = classnames.bind(styles)

const Pin = ({ className }) => (
  <Icon
    className={cx('root', className)}
    name='map-marker-alt'
    size='huge'
    iconStyle='solid'
    color='error'
  />
)

Pin.propTypes = {
  className: PropTypes.string,
}

export default Pin
